import React from "react";
import PropTypes from "prop-types";
import TextBlock from "../../components/ui/TextBlock";
import "./SpecColumnTile.scss";

const SpecColumnTile = ({
	imageSrc,
	imageSrcMobile,
	imageAlt,
	eyebrow,
	title,
	paragraph,
	className,
}) => {
	return (
		<section
			className={`spec-column-tile spec-column-tile--column ${className || ""} global-padding`.trim()}>
			<div className="spec-column-tile__content">
				<div className="spec-column-tile__content__left">
					<TextBlock
						paragraph={eyebrow}
						fontSize={16}
						fontWeight={600}
						color="black"
						align="left"
					/>
					<TextBlock
						paragraph={title}
						fontSize={32}
						fontWeight={400}
						color="black"
						align="left"
					/>
				</div>
				<div className="spec-column-tile__content__right">
					<TextBlock
						paragraph={paragraph}
						fontSize={20}
						fontWeight={280}
						color="black"
						align="left"
					/>
				</div>
			</div>
			<div className="spec-column-tile__media">
				{imageSrcMobile ? (
					<>
						<img
							src={imageSrc}
							alt={imageAlt}
							className="spec-column-tile__image spec-column-tile__image--desktop"
							loading="lazy"
						/>
						<img
							src={imageSrcMobile}
							alt={imageAlt}
							className="spec-column-tile__image spec-column-tile__image--mobile"
							loading="lazy"
						/>
					</>
				) : (
					<img
						src={imageSrc}
						alt={imageAlt}
						className="spec-column-tile__image"
						loading="lazy"
					/>
				)}
			</div>
		</section>
	);
};

SpecColumnTile.propTypes = {
	imageSrc: PropTypes.string.isRequired,
	imageSrcMobile: PropTypes.string,
	imageAlt: PropTypes.string.isRequired,
	eyebrow: PropTypes.string,
	title: PropTypes.string,
	paragraph: PropTypes.string,
	className: PropTypes.string,
};

SpecColumnTile.defaultProps = {
	eyebrow: "",
	title: "",
	paragraph: "",
	className: "",
	imageSrcMobile: null,
};

export default SpecColumnTile;
